import { request } from "@/utils/request";

// const BASE_URL = `${process.env.VUE_APP_API_URL}`;
// const BASE_URL = `https://testservice.ehanghai.cn/ehh-api`;
const BASE_URL = `https://hhzx.ehanghai.cn/ehh-api`;
const METEOROLOGY_FORECAST_TIME_API = {
  wind: "/weather/prod/wind/forecast/v1/get_forecast_time",
  waves: "/weather/prod/waves/forecast/v1/get_forecast_time",
  pressure: "/weather/prod/pressure/forecast/v1/get_forecast_time",
  visibility: "/weather/prod/visibility/forecast/v1/get_forecast_time",
  currents: "/weather/prod/sea_currents/forecast/v1/get_forecast_time",
  rainaccumulationlog:
    "/weather/prod/sea_currents/forecast/v1/get_forecast_time",
  temp: "/weather/prod/temperature/forecast/v1/get_forecast_time",
  temperature: "/weather/prod/temperature/forecast/v1/get_forecast_time",
  rainAccu: "/weather/prod/rain_accumulation/forecast/v1/get_forecast_time",
};

// 气象时间刻度
export function getMeteorologyForecastTime(layerId) {
  return request(
    `${BASE_URL}` + METEOROLOGY_FORECAST_TIME_API[layerId] ||
      METEOROLOGY_FORECAST_TIME_API.wind,
    {
      method: "get",
      params: {
        _t: Date.now(),
      },
    },
  );
}

// 获取全部海区列表
export function getAllSeaAreas(params) {
  return request(
    `${BASE_URL}` + "/weather/prod/sea_area/forecast/v1/get_all_sea_area",
    {
      method: "get",
      params,
    },
  );
}

// 获取所有海区当前气象数据
export function getSeaAreasWithCurrentForecast(params) {
  return request(
    `${BASE_URL}` +
      "/weather/prod/sea_area/forecast/v1/get_areas_with_current_forecast",
    {
      method: "get",
      params,
    },
  );
}

// 获取所有海区全量气象预报数据
export function getSeaAreasWithAllForecast(params) {
  return request(
    `${BASE_URL}` +
      "/weather/prod/sea_area/forecast/v1/get_areas_with_all_forecast",
    {
      method: "get",
      params,
    },
  );
}
